<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_1"></a>The Window at the White Cat</h1>
<p class="author">By Mary Roberts Rinehart</p>
<div class="img_container1">
<img alt="image" src="images/logo3.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?08b5309a